module.exports = __webpack_public_path__ + "static/media/36-9.e2905602.mp3";